import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
} from "../../../../services/index";
declare var google;

@Component({
  selector: "stock-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./SoReport.component.html",
})
export class DesignWiseSalesOrderReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  brandList = [];
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  gridOptions: any;
  data: any;
  styleList = [];
  typeList = [];
  agentName = "";
  filtertypeList = [
    "AGENT",
    "PARTY",
    "SEASON",
    "DESIGN NO",
    "ORDERWISE",
    "DESIGN COLOR",
    "BRAND",
    "STYLE",
  ];
  orderTypeList = ["Order Form", "Open Order"];
  sizeMenu = ["YES", "NO"];
  colorList = [];
  qualityList = [];
  exceldata: any;
  tileViewGroup = ["DESIGN NO", "COLOR", "DESIGN COLOR"];
  fitList = [];
  partyList = [];
  partyAgentList = [];
  agentList = [];
  seasonList = [];
  finyearList = [];
  seasonfinList = [];
  designList = [];
  listSelected: any = [];
  dataList: any[];
  viewTypeList = ["GRID", "TILE"];
  designTypeList = ["CORE", "NEW"];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  user: any;
  viewType = "GRID";
  designData: any;
  newlistSelected = [];
  newDesignList = [];
  coreDesignList = [];
  agentVisible: boolean = false;
  flag: boolean = false;
  clear: boolean = false;
  filter = {
    design_type: "",
    finyear: "",
    fin_id: "3",
    party_id: "",
    agent_id: "",
    season_id: "3",
    groupby: "BRAND",
    order_type: "",
    design_no: "",
    newdesignno: "",
    design: [],
    new_design_no: [],
    brand: [],
    style: [],
    type: [],
    fit: [],
    quality: [],
    color: [],
    orderArray: [],
    coreArray: [],
    season: "",
    party_name: "",
    agent_name: "",
    sales_from: "",
    sales_to: "",
    mrp_from: "",
    mrp_to: "",
    so_from: "",
    so_to: "",
    sizeCols: "YES",
    ftot_from: "",
    ftot_to: "",
    htot_from: "",
    htot_to: "",
    tot_to: "",
    tot_from: "",
    order_from: "",
    order_to: "",
    viewtype: "GRID",
  };
  dispName = [];
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "agent_name",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Agent Yearly report",
    columns: [],
    rows: [],
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    name: "",
    //company_id: 0
  };

  @Input() set params(val: any[]) {
    if (val["chkData"] == true) {
      this.filter["groupby"] = "PARTY DESIGN";
      this.flag = true;
      if (val["data"].design_type == "NEW") {
        this.OnSelectnewdesign(val["data"].design_no);
      } else {
        this.OnSelectcoredesign(val["data"].design_no);
      }
      this.filter["shade"] = val["data"].code;
      this.filter.season_id = val["data"].season_id;
      this.filter.fin_id = val["data"].fin_id;
      val["chkData"] = false;
    } else {
      this.filter = {
        design_type: "",
        finyear: "",
        fin_id: "3",
        party_id: "",
        agent_id: "",
        season_id: "3",
        groupby: "BRAND",
        order_type: "",
        design_no: "",
        newdesignno: "",
        design: [],
        new_design_no: [],
        brand: [],
        style: [],
        type: [],
        fit: [],
        quality: [],
        color: [],
        orderArray: [],
        coreArray: [],
        season: "",
        party_name: "",
        agent_name: "",
        sales_from: "",
        sales_to: "",
        mrp_from: "",
        mrp_to: "",
        so_from: "",
        so_to: "",
        sizeCols: "YES",
        ftot_from: "",
        ftot_to: "",
        htot_from: "",
        htot_to: "",
        tot_to: "",
        tot_from: "",
        order_from: "",
        order_to: "",
        viewtype: "GRID",
      };
    }
  }

  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private reportService: ReportService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private combo: Combo2Service
  ) {}

  ngOnInit(): void {
    this.brandCombo();
    this.styleCombo();
    this.fitCombo();
    this.qualityCombo();
    this.colorCombo();
    this.typeCombo();
    this.finyearCombo();
    this.agentCombo();
    this.seasonCombo();
    this.designCombo();
    this.partyCombo();
    this.coreDesignCombo();
    this.newDesignCombo();
    this.getAgentYearlyReport();

    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      maxHeight: window.innerHeight - 300 + "px",
      loading: true,
      data: [],
    };
    this.designData = {
      cols: [],
      data: [],
      groupby: "DESIGN NO",
    };
    this.toggleCol = Object.assign({}, this.columns);
    // this.pageCallback({ offset: 0 });
    this.checkuser();
  }

  checkuser() {
    let that = this;

    if (this.user.params && !this.user.params.agent_id) {
      that.agentVisible = true;
    }
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  onOpenedFilter(): void {}

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getAgentYearlyReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  setData(data) {
    this.data = Object.assign({}, data);
  }

  OnSelectdesignno($event) {
    this.listSelected.push($event.item.design_no);
    this.filter["design"] = this.listSelected;
    //  this.filter['design_no'] = '';
  }

  brandCombo() {
    let that = this;
    this.combo.brandCombo().then((res: any) => {
      that.brandList = res.data;
    });
  }
  designCombo() {
    let that = this;
    this.combo.designCombo().then((res: any) => {
      that.designList = res.data;
    });
  }
  qualityCombo() {
    let that = this;
    this.combo.qualityCombo().then((res: any) => {
      that.qualityList = res.data;
    });
  }
  typeCombo() {
    let that = this;
    this.combo.typeCombo().then((res: any) => {
      that.typeList = res.data;
    });
  }
  colorCombo() {
    let that = this;
    this.combo.colorCombo().then((res: any) => {
      that.colorList = res.data;
    });
  }
  fitCombo() {
    let that = this;
    this.combo.fitCombo().then((res: any) => {
      that.fitList = res.data;
    });
  }
  styleCombo() {
    let that = this;
    this.combo.styleCombo().then((res: any) => {
      that.styleList = res.data;
    });
  }

  partyCombo() {
    let that = this;
    this.combo.partyCombo().then((res: any) => {
      that.partyList = res.data;
    });
  }
  agentCombo() {
    let that = this;

    this.combo.agentCombo().then((res: any) => {
      that.agentList = res.data;
      setTimeout(function () {
        that.displayAgent("Agent", that.user.params.agent_id);
      }, 200);
    });
  }
  seasonCombo() {
    let that = this;
    this.combo.seasonCombo().then((res: any) => {
      that.seasonList = res.data;
      if (that.flag == false) {
        that.seasonCtrl.setValue(res.data[0].season_id);

        that.getAgentYearlyReport();
      } else {
        that.seasonCtrl.setValue(that.filter.season_id);
        that.getAgentYearlyReport();
      }
    });
  }

  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      if (that.flag == false) {
        that.finyearCtrl.setValue(res.data[0].fin_id);
        that.onSelectFinyear(res.data[0].fin_id);
      } else {
        that.finyearCtrl.setValue(that.filter.fin_id);
      }
    });
  }
  onSelectAgent(id) {
    let partyAgentList = _.filter(this.partyList, { agent_id: id });
    this.partyAgentList = partyAgentList;
  }

  onSelectFinyear(id) {
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
  }

  newDesignCombo() {
    let that = this;
    this.combo.newDesignCombo().then((res: any) => {
      that.newDesignList = res;
    });
  }
  coreDesignCombo() {
    let that = this;
    this.combo.coreDesignCombo().then((res: any) => {
      that.coreDesignList = res;
    });
  }
  onClickCore(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["design_type"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  onClickCheck(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["brand"] = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckstyle(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["style"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickChecktype(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["type"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckfit(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["fit"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckquality(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["quality"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckcolor(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["color"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  OnSelectcoredesignno($event) {
    //
    this.listSelected.push($event.item.design_no);
    this.filter["corelist"] = this.listSelected;
    this.filter["design"] = this.listSelected;
    this.filter["design_no"] = "";
  }

  OnSelectnewdesignno($event) {
    //
    this.newlistSelected.push($event.item.design_no);
    this.filter["corelist"] = this.newlistSelected;
    this.filter["design"] = this.newlistSelected;
    this.filter["newdesignno"] = "";
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "applyFilter") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      this.applyFilter();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getAgentYearlyReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getAgentYearlyReport();
  }

  addDateParam(field, filter) {
    if (filter[field] && filter[field] !== null) {
      filter[field] = this.datePipe.transform(filter[field], "yyyy-MM-dd");
    } else {
      filter[field] = "";
    }
  }

  onbackbutton(group) {
    if (group == "DESIGN COLOR") {
      this.filter.groupby = "DESIGN NO";
      this.filter["shade"] = "";
      this.listSelected = [];
      this.newlistSelected = [];
      this.filter["corelist"] = [];
      this.filter["design_no"] = this.listSelected;
      this.filter.newdesignno = "";
      this.getAgentYearlyReport();
    } else if (group == "COLOR") {
      this.filter.groupby = "DESIGN NO";
      this.filter["shade"] = "";
      this.listSelected = [];
      this.newlistSelected = [];
      this.filter["corelist"] = [];
      this.filter["design_no"] = this.listSelected;
      this.filter.newdesignno = "";
      this.getAgentYearlyReport();
    } else if (group == "PARTY DET") {
      this.filter.groupby = "COLOR";
      this.filter["shade"] = "";

      this.getAgentYearlyReport();
    }
  }

  onCellClick(event, groupby) {
    if (this.filter.groupby == "DESIGN NO") {
      this.filter.groupby = "DESIGN COLOR";
      if (event.row.design_type == "NEW") {
        this.OnSelectnewdesign(event.row.design_no);
      } else {
        this.OnSelectcoredesign(event.row.design_no);
      }

      this.getAgentYearlyReport();
    } else if (this.filter.groupby == "DESIGN COLOR") {
      this.onClickColor(event);
    }
  }

  OnSelectnewdesign(value) {
    this.filter.newdesignno = "";
    this.newlistSelected.push(value);
    this.filter["corelist"] = this.newlistSelected;
    this.filter["new_design_no"] = this.newlistSelected;
    this.filter["newdesignno"] = "";
  }

  OnSelectcoredesign(value) {
    this.filter.design_no = "";
    this.listSelected.push(value);
    this.filter["corelist"] = this.listSelected;
    this.filter["design"] = this.listSelected;
    this.filter["design_no"] = "";
  }

  onClickColor(event) {
    let tabObj = {};
    this.clear = true;
    let chkData = this.clear;
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ORDER_REPORTS",
        title: "ORDER REPORT",
        tabParent: "REPORTS",
        data: event.row,
        chkData: chkData,
        name: "DesignWiseSalesOrderReport",
      },
    };

    this.tabUpdateEvent.emit(tabObj);
  }

  getAgentYearlyReport(): void {
    if (this.filter.party_name == "") {
      this.filter["party_id"] = "";
    }
    let filter = Object.assign({}, this.filter);
    this.addDateParam("sales_from", filter);
    this.addDateParam("sales_to", filter);

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(filter),
      dispName: JSON.stringify(this.dispName),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getSalesOrderReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.dataList = res.data;
        that.columns = res.columns;
        that.gridOptions = {
          columns: res.columns,
          cols: res.cols,
          data: res.data,
          loading: false,
        };
        if (that.filter.viewtype == "TILE") {
          that.viewType = "TILE";
        } else {
          that.viewType = "GRID";
        }

        that.designData = {
          cols: res.cols,
          data: res.data,
          name: "Order",
          groupby: that.filter.groupby,
        };
        that.page.count = res.total;
        that.refreshData();
        that.exceldata = that.getData(res.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        that.printConfig = {
          title: "Sales Order report",
          columns: that.gridOptions.columns,
          rows: that.gridOptions.data,
        };
        //  that.columns = res.columns;
      });
  }
  onClickOrder(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["order_type"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onChangePhoto(status) {
    if (status == true) {
      this.filter.sizeCols = "";
    }
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.filterData = {
      name: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    this.filter["corelist"] = this.filter.design.concat(
      this.filter.new_design_no
    );
    if (this.filter.orderArray.length == 1) {
      this.filter.order_type = this.filter.orderArray[0];
    } else {
      this.filter.order_type = "";
    }
    if (this.filter.coreArray.length == 1) {
      this.filter.design_type = this.filter.coreArray[0];
    } else {
      this.filter.design_type = "";
    }
    //this.filterExpand = false;
    this.filterPanel.close();
    this.viewType = "GRID";

    this.getAgentYearlyReport();
    // this.filter['design_no'] = '';
  }

  displayAgent(comboType: string, id: number) {
    let list: any = [];
    let agent_id = id + "";
    if (comboType == "Agent") {
      list = this.agentList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { agent_id: agent_id });
      this.agentName = fitem["agent_name"];
      return fitem["agent_name"];
    }
    return "";
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  displaySeason(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    list = this.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }
  onSelectParty($event) {
    let party_id = $event.item.party_id;
    this.filter["party_id"] = party_id;
  }

  onRowSelected($event) {
    let data = Object.assign($event.selected[0]);
    //  data['fin_id'] = this.filter.fin_id;
    const tabObj = {
      action: "NewTab",
      params: {
        tabParent: "REPORTS",
        tabName: "PartySalesOrderReport",
        type: "order",
        mode: "View",
        data: data,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList;
    this.page.count = data.length;
    // this.dataList = data;
  }

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/salesOrderReport/SoReport.component.ts